import React from "react";

import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { PublishingData } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import styles from "./Publishing.module.css";

export default function Publishing() {
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_PUBLISHING_OUTCOMES
  );
  const apiData = response?.publishingOutcome1 ?? PublishingData;
  const navigate = useNavigate();
  const formatToIST = (datetime) => {
    const date = new Date(datetime + " UTC");

    const datePart = date.toLocaleDateString("en-US", {
      timeZone: "Asia/Kolkata",
      month: "long",
      day: "2-digit",
      year: "numeric",
    });

    const timePart = date.toLocaleTimeString("en-US", {
      timeZone: "Asia/Kolkata",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${datePart} | ${timePart} IST`;
  };

  return (
    <section className={styles.publishing}>
      <div className={styles.container}>
        <h3>
          Publishing <span>& Outcomes</span>
        </h3>
        <div className={styles.cards}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData.slice(0, 3).map((i) => (
              <article className={styles.card} key={i.id}>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_ASSETS_BASE_URL || "https://api.imparc.site/assets/uploads/"}` + i.image}
                    alt={i.title}
                  />
                </figure>
                <div className={styles.content}>
                  <h4>{i.title}</h4>
                  <div className={styles.text}>{i.heading}</div>
                  <div className={i.datetime && styles.time}>
                    {formatToIST(i.datetime)}&nbsp;
                  </div>
                  <button onClick={() => navigate(i.link)}>
                    {i.button_name || "Button"}
                  </button>
                </div>
              </article>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
